require('../scss/security.scss');
const $ = require('jquery');
import 'select2';

document.addEventListener('DOMContentLoaded', () => {
    initCustomFields();
});

const initCustomFields = () => {
    const customSelects = $("[data-custom-field='reference']:not('.required')");
    const requiredSelect = $(".required[data-custom-field='reference']");

    customSelects.select2({
        allowClear: true
    });
    requiredSelect.select2();
};
